<template>
<div class="wait-report-page page-with-tabbar">
    <van-nav-bar 
        title="待处理"
        fixed 
        :placeholder="true"
    >
        <template #right>
            <van-button size="small" type="default" @click="goToTicket" class="records-btn">
                已上报
            </van-button>
        </template>
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <div class="order-list">
        <van-skeleton v-if="loading && orderList.length === 0" class="product-skeleton" title :row="5" />
        <!-- 这里循环渲染订单卡片组件，后续可复用OrderCard.vue -->
        <div v-for="item in orderList" :key="item.order_id" class="order-card">
            <div class="card-top">
                <div class="top-left">
                    <div class="cinema-name">{{ item.cinema_name }}</div>
                    <div class="order-row">
                        <span class="order-id">{{ item.order_id }}</span>
                        <span class="copy-btn" @click="copyOrderNo(item.order_id)">复制</span>
                    </div>
                </div>
                <div class="top-right">
                    <span class="status-text">{{ item.status == 10 ? '待上报' : '待接单' }}</span>
                    <div class="market-price">市场价:￥{{ item.channel_price }}</div>
                </div>
            </div>
            <div class="card-middle">
                <div class="movie-img-box">
                    <van-image width="80px" height="100px" fit="cover" :src="item.logo+'_200x200'" />
                </div>
                <div class="movie-info-box">
                    <div class="movie-title-row">
                        <div class="movie-title">{{ item.movie_name }}</div>
                        <div class="city-name">{{ item.city_name }}</div>
                    </div>
                    <div class="showtime-row">
                        <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                        <span class="showtime">{{ item.play_time_text }}</span>
                    </div>
                    <div class="hall-name" v-if="item.hall_name">{{ item.hall_name }}</div>
                    <div class="movie-tags">
                        <span class="ticket-count">{{ item.quantity }}张</span>
                        <span v-if="item.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
                        <span v-if="item.support_exchange_seat === 'Y'" class="seat-type-tag">九宫格换座</span>
                    </div>
                </div>
            </div>
            <div class="card-bottom">
                <div class="my-bid">已报价:<span style="color: #ff2c54;font-weight: bold;">￥{{ item.bid_price }}</span></div>
                <van-button
                  v-if="item.status != 10"
                  size="small"
                  type="danger"
                  class="action-btn accept-btn"
                  :class="{ 'disabled': item.remaining <= 0 }"
                  @click="acceptOrder(item)"
                  :disabled="item.remaining <= 0"
                >
                  <span class="accept-text">接单</span>
                  <span class="countdown-in-btn">
                    <van-count-down v-if="item.remaining > 0" :time="item.remaining * 1000" format="mm:ss" />
                    <span v-else class="expired-text">已结束</span>
                  </span>
                </van-button>
                <van-button
                  v-if="item.status == 10"
                  size="small"
                  type="danger"
                  class="action-btn accept-btn"
                  :class="{ 'disabled': item.remaining <= 0 }"
                  @click="reportOrder(item)"
                  :disabled="item.remaining <= 0"
                >
                  <span class="accept-text">上报</span>
                  <span class="countdown-in-btn">
                    <van-count-down v-if="item.remaining > 0" :time="item.remaining * 1000" format="mm:ss" />
                    <span v-else class="expired-text">已结束</span>
                  </span>
                </van-button>
            </div>
        </div>
        <van-empty v-if="!loading && orderList.length === 0" class="product-empty" image="search" :description="loadError ? '加载失败，请检查网络后重试' : '暂无待处理订单'">
            <van-button size="small" plain type="primary" @click="fetchData">重新加载</van-button>
        </van-empty>
    </div>
    </van-pull-refresh>
</div>
</template>

<script>
import Api from '@/api-service'
import {
    Toast
} from 'vant'
import { mapMutations } from 'vuex'

export default {
    name: 'WaitReport',
    data() {
        return {
            orderList: [],
            loading: false,
            isFetching: false,
            loadError: false,
            refreshing: false,
            finished: false,
            queryData: {
                page: 1,
                pageSize: 100
            },
            timer: null
        }
    },
    created() {
        this.fetchData()
        this.startTimer()
    },
    beforeDestroy() {
        this.clearTimer()
    },
    beforeRouteLeave(to, from, next) {
        this.clearTimer()
        next()
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.startTimer()
        })
    },
    methods: {
        ...mapMutations(['setPendingConfirmCount']),
        startTimer() {
            this.clearTimer()
            this.timer = setInterval(() => {
                this.fetchData({ silent: true })
            }, 5000)
        },
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        fetchData(options = {}) {
            if (this.isFetching) {
                this.refreshing = false
                return
            }
            const silent = options.silent === true
            this.isFetching = true
            this.loadError = false
            if (!silent) this.loading = true;
            Api.getWaitOrderList({
                page: this.queryData.page,
                pageSize: this.queryData.pageSize
            }).then(res => {
                this.loading = false;
                this.isFetching = false;
                this.refreshing = false;
                this.orderList = res.list || [];
                // 使用服务端同口径总数；接口未返回 total 时兼容旧版本
                const total = Number(res.total)
                this.setPendingConfirmCount(Number.isFinite(total) ? total : this.orderList.length)
                if (res.list && res.list.length < this.queryData.pageSize) {
                    this.finished = true;
                }
            }).catch(() => {
                this.loading = false;
                this.isFetching = false;
                this.loadError = true;
                this.refreshing = false;
            })
        },
        onRefresh() {
            this.queryData.page = 1
            this.finished = false
            this.fetchData()
        },
        copyOrderNo(orderNo) {
            if (!orderNo) return
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(orderNo).then(() => {
                    Toast('复制成功')
                })
            }
        },
        acceptOrder(order) {
            if (order.remaining <= 0) {
                this.$toast('订单已结束，无法接单');
                return;
            }
            
            this.$router.push({
                name: 'ConfirmOrder',
                query: {
                    order: encodeURIComponent(JSON.stringify(order))
                }
            });
        },
        reportOrder(order) {
            if (order.remaining <= 0) {
                this.$toast('订单已结束，无法上报');
                return;
            }
            
            this.$router.push({
                name: 'UploadTicketCode',
                query: {
                    order_id: order.order_id
                }
            });
        },
        goToTicket() {
            console.log('跳转到已出票页面');
            this.$router.push({
                name: 'Ticket'
            }).catch(err => {
                console.error('路由跳转失败:', err);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.wait-report-page {
    background: #f7f7fa;
    padding-bottom: calc(50px + env(safe-area-inset-bottom, 0px));

    .records-btn {
        font-size: 12px;
        height: 28px;
        padding: 0 12px;
        border-radius: 6px;
        border: 1px solid #667eea;
        background: white;
        color: #667eea;
        font-weight: 500;
        transition: all 0.3s ease;

        &:active {
            background: rgba(102, 126, 234, 0.1);
            transform: scale(0.95);
        }
    }

    .order-list {
        padding: 16px 8px 0 8px;
    }

    .empty-tip {
        text-align: center;
        color: #888;
        margin-top: 40px;
        font-size: 15px;
    }
}

.order-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    margin-bottom: 18px;
    padding: 14px 12px 12px 12px;
    display: flex;
    flex-direction: column;

    .card-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 8px;
    }

    .cinema-name {
        font-weight: bold;
        font-size: 16px;
        color: #222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: min(200px, 100%);
    }

    .order-row {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #888;
        margin-top: 2px;
    }

    .order-id {
        margin-right: 8px;
    }

    .copy-btn {
        color: #409eff;
        cursor: pointer;
    }

    .status-text {
        color: #ff2c54;
        font-size: 14px;
        font-weight: bold;
        display: block;
        text-align: right;
    }

    .market-price {
        font-size: 13px;
        color: #888;
        margin-top: 2px;
        text-align: right;
    }

    .card-middle {
        display: flex;
        align-items: flex-start;
        margin-bottom: 8px;
    }

    .movie-img-box {
        width: 80px;
        height: 100px;
        border-radius: 4px;
        margin-right: 12px;
        overflow: hidden;
    }

    .movie-info-box {
        flex: 1;
        min-width: 0;
    }

    .movie-title-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .movie-title {
        font-size: 15px;
        font-weight: 500;
        color: #333;
    }

    .city-name {
        font-size: 13px;
        color: black;
        margin-left: auto;
    }

    .showtime-row {
        font-size: 13px;
        color: #333;
        margin-top: 8px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .today-tag {
        display: inline-block;
        color: white;
        background-color: #ff2c53da;
        font-size: 12px;
        font-weight: bold;
        padding: 2px 6px 2px 4px;
        margin-right: 2px;
        line-height: 1.2;
        vertical-align: middle;
        border-radius: 2px;
    }

    .hall-name {
        font-size: 13px;
        color: #888;
        margin-bottom: 2px;
    }

    .movie-tags {
        margin-top: 4px;
    }

    .ticket-count {
        background: #f7f8fa;
        border-radius: 8px;
        font-size: 10px;
        padding: 1px 1px;
    }

    .seat-type-tag {
        border: 2px solid rgb(0, 140, 255);
        color: rgb(0, 140, 255);
        border-radius: 2px;
        font-size: 10px;
        font-weight: bold;
        padding: 2px 2px;
        margin-left: 4px;
    }
    
    .couple-seat {
        border: 2px solid #ff2c54;
        color: #ff2c54;
        background-color: #fff2f0;
    }

    .card-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .my-bid {
        // color: #ff2c54;
        font-size: 14px;
    }

    .action-btns {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
    }

    .accept-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 90px;
        flex-shrink: 0;
        border-radius: 4px;
        overflow: hidden;
        width: 100px;
        padding: 0 2px;

        .accept-text {
            font-weight: bold;
            font-size: 14px;
        }

        .countdown-in-btn {
            color: #ff2c54 !important;
            font-weight: bold;
            border-radius: 2px;
            background-color: white;
            font-size: 14px;
            margin-left: 18px;
            min-width: 40px;
            display: inline-block;
            text-align: right;
            padding: 0 4px;
            ::v-deep .van-count-down {
                color: #ff2c54 !important;
            }

            .expired-text {
                color: #999 !important;
                font-size: 12px;
            }
        }

        &.disabled {
            background: #f5f5f5 !important;
            border-color: #ccc !important;
            color: #999 !important;
            cursor: not-allowed;

            .accept-text {
                color: #999 !important;
            }

            .countdown-in-btn {
                color: #999 !important;
                background-color: #f5f5f5 !important;
            }
        }
    }
}
</style>
